export const FUNNEL_OPTIONS = [
  { slug: "standard", title: "Standard Form" },
  { slug: "quiz", title: "Quiz-Style Form" },
  { slug: "quiz-v2", title: "Quiz V2 (App-Style)" },
  { slug: "focused", title: "Focused Funnel" },
  { slug: "auto", title: "Car Accident" },
  { slug: "truck", title: "Truck / 18-Wheeler" },
  { slug: "rideshare", title: "Rideshare (Uber / Lyft)" },
  { slug: "motorcycle", title: "Motorcycle" },
  { slug: "injury", title: "Personal Injury (All-in-One)" },
];
export const ALL_FUNNELS = FUNNEL_OPTIONS.map((f) => f.slug);
export const VERTICAL_FUNNELS = ["auto", "truck", "rideshare", "motorcycle"];

export const funnelTitle = (slug) => FUNNEL_OPTIONS.find((f) => f.slug === slug)?.title || slug;

// [] (or every funnel) means the buyer takes leads from all shared funnels.
export const picksLabel = (picks) => (
  !picks || !picks.length || picks.length === ALL_FUNNELS.length ? "All funnels" : picks.map(funnelTitle).join(", ")
);

export const picksOrAll = (picks) => (picks && picks.length ? picks : ALL_FUNNELS);
